import axios from 'axios'
export default {
  name: 'zhgl',
  components: {},
  data () {
    return {
      // 搜索框输入value
      inputValue: '',
      // 下拉选择value
      selectValue: '主题',
      // 搜索下拉框数据
      options: [],
      // 陈列展览导航数组
      clzlNaviList: [],
      // 陈列展览导航选中
      clzlSelect: '',
      clzlName: '',
      // 陈列展览数据
      clzlList: [],
      // 社会教育导航数组
      shjyNaviList: [],
      // 社会教育导航选中
      shjySelect: '',
      shjyName: '',
      // 社会教育数据
      shjyList: [],
      // 公共关系导航数组
      gggxNaviList: [],
      // 公共关系导航选中
      gggxSelect: '',
      gggxName: '',
      // 公共关系数据
      gggxList: [],
      // 藏品管理导航数组
      cpglNaviList: [],
      // 藏品管理导航选中
      cpglSelect: '',
      cpglName: '',
      // 藏品管理数据
      cpglList: [],
      // 建设管理导航数组
      jsglNaviList: [],
      // 建设管理导航选中
      jsglSelect: '',
      jsglName: '',
      // 建设管理数据
      jsglList: [],
      // 纪念设施导航数组
      jnssNaviList: [],
      // 纪念设施导航选中
      jnssSelect: '',
      jnssName: '',
      // 纪念设施数据
      jnssList: [],
      // 风景园林导航数组
      fjylNaviList: [],
      // 风景园林导航选中
      fjylSelect: '',
      fjylName: '',
      // 风景园林数据
      fjylList: []
    }
  },
  // 创建元素
  mounted () {
    this.init()
  },
  // 方法定义
  methods: {
    // 初始化
    init () {
      // 获取搜索栏下拉框
      this.getSelectData()
      // 获取导航数据
      this.getZHGLType()
    },

    // 获取搜索栏下拉框
    getSelectData () {
      axios.get('/yuhuamenhu/special/getAllQueryCriteria').then(res => {
        if (res.status === 200) {
          this.options = JSON.parse(JSON.stringify(res.data.data))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 检索
    handleSearch () {
      const detail = this.$router.resolve({
        path: '/moreSearch',
        query: {
          module: '综合管理研究',
          fieldName: this.selectValue,
          queryName: this.inputValue
        }
      })
      window.open(detail.href, '_blank')
    },

    // 获取导航数据
    getZHGLType () {
      const self = this
      axios.get('/yuhuamenhu/special/getZHGLType').then(json => {
        if (json.data.code === 200) {
          this.update(json.data.data)
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingQuality = false
      })
    },

    // 处理数据
    update (navi) {
      // 陈列展览导航数组
      this.clzlNaviList = navi[0].children
      this.clzlSelect = this.clzlNaviList[0].id
      this.clzlName = this.clzlNaviList[0].name
      this.getDataList(this.clzlNaviList[0].id, 'clzl')
      // 社会教育导航数组
      this.shjyNaviList = navi[1].children
      this.shjySelect = this.shjyNaviList[0].id
      this.shjyName = this.shjyNaviList[0].name
      this.getDataList(this.shjyNaviList[0].id, 'shjy')
      // 公共关系导航数组
      this.gggxNaviList = navi[2].children
      this.gggxSelect = this.gggxNaviList[0].id
      this.gggxName = this.gggxNaviList[0].name
      this.getDataList(this.gggxNaviList[0].id, 'gggx')
      // 藏品管理导航数组
      this.cpglNaviList = navi[3].children
      this.cpglSelect = this.cpglNaviList[0].id
      this.cpglName = this.cpglNaviList[0].name
      this.getDataList(this.cpglNaviList[0].id, 'cpgl')
      // 建设管理导航数组
      this.jsglNaviList = navi[4].children
      this.jsglSelect = this.jsglNaviList[0].id
      this.jsglName = this.jsglNaviList[0].name
      this.getDataList(this.jsglNaviList[0].id, 'jsgl')
      // 纪念设施导航数组
      this.jnssNaviList = navi[5].children
      this.jnssSelect = this.jnssNaviList[0].id
      this.jnssName = this.jnssNaviList[0].name
      this.getDataList(this.jnssNaviList[0].id, 'jnss')
      // 风景园林导航数组
      this.fjylNaviList = navi[6].children
      this.fjylSelect = this.fjylNaviList[0].id
      this.fjylName = this.fjylNaviList[0].name
      this.getDataList(this.fjylNaviList[0].id, 'fjyl')
    },

    // 获取列表数据
    getDataList (id, code) {
      const self = this
      const data = {
        fieldName: '',
        orderField: '',
        orderType: '',
        pageNo: 1,
        pageSize: 5,
        queryName: '',
        ywfldm: [id]
      }
      axios.post('/yuhuamenhu/special/getSpecialData', data).then(json => {
        if (json.data.code === 200) {
          this.assignList(json.data.data.rows, code)
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingQuality = false
      })
    },

    // 给各个接口赋值
    assignList (list, code) {
      switch (code) {
        case 'clzl':
          this.clzlList = list
          break
        case 'shjy':
          this.shjyList = list
          break
        case 'gggx':
          this.gggxList = list
          break
        case 'cpgl':
          this.cpglList = list
          break
        case 'jsgl':
          this.jsglList = list
          break
        case 'jnss':
          this.jnssList = list
          break
        case 'fjyl':
          this.fjylList = list
          break
      }
    },

    // 点击导航获取数据
    getData (item, code) {
      switch (code) {
        case 'clzl':
          this.clzlSelect = item.id
          this.clzlName = item.name
          break
        case 'shjy':
          this.shjySelect = item.id
          this.shjyName = item.name
          break
        case 'gggx':
          this.gggxSelect = item.id
          this.gggxName = item.name
          break
        case 'cpgl':
          this.cpglSelect = item.id
          this.cpglName = item.name
          break
        case 'jsgl':
          this.jsglSelect = item.id
          this.jnssName = item.name
          break
        case 'jnss':
          this.jnssSelect = item.id
          this.jnssName = item.name
          break
        case 'fjyl':
          this.fjylSelect = item.id
          this.fjylName = item.name
          break
      }
      this.getDataList(item.id, code)
    },

    // 点击前往更多
    goMore (code) {
      let param = ''
      switch (code) {
        case 'clzl':
          param = this.clzlSelect
          break
        case 'shjy':
          param = this.shjySelect
          break
        case 'gggx':
          param = this.gggxSelect
          break
        case 'cpgl':
          param = this.cpglSelect
          break
        case 'jsgl':
          param = this.jsglSelect
          break
        case 'jnss':
          param = this.jnssSelect
          break
        case 'fjyl':
          param = this.fjylSelect
          break
      }
      const search = this.$router.resolve({
        path: '/moreSearch',
        query: {
          module: '综合管理研究',
          type: param,
          fieldName: this.selectValue,
          queryName: this.inputValue

        }
      })
      window.open(search.href, '_blank')
    },

    // 点击前往详情
    goDetail (val) {
      const detail = this.$router.resolve({
        path: '/yjztDetail',
        query: {
          name: val.name,
          from: val.from
        }
      });
      window.open(detail.href, '_blank')
    }
  }
}
